import axios from '../../../axiosConfig';

export async function getVendors(config = {}, clientId) {
    return await axios.get(`/v1/vendor/all/${clientId}`, config);
}

export async function getVendorsSimple(clientId, config = {}) {
    return await axios.get(`/v1/vendor/${clientId}/simple`, config);
}

export async function getVendorById(id, config = {}) {
    return await axios.get(`/v1/vendor/${id}`, config);
}

export async function createVendor(data, config = {}) {
    return await axios.post(`/v1/vendor`, data, config);
}

export async function updateVendor(data, config = {}) {
    return await axios.put(`/v1/vendor/${data.id}`, data, config);
}

export async function deleteVendor(vendorId, config = {}) {
    return await axios.delete(`/v1/vendor/${vendorId}`, config);
}

const functions = { getVendors, getVendorsSimple, getVendorById, createVendor, updateVendor, deleteVendor }
export default functions
